"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.profileSettingsFailure = exports.profileSettingsSuccess = exports.fetchProfileSettingsRequest = exports.createPolicyFailure = exports.createPolicySuccess = exports.createPolicyLoading = exports.createPolicyRequest = exports.recursivePermissionListReset = exports.recursivePermissionListFail = exports.recursivePermissionListSuccess = exports.recursivePermissionListDisableLoading = exports.recursivePermissionListLoading = exports.recursivePermissionListRequest = exports.recursiveRoleListReset = exports.recursiveRoleListFail = exports.recursiveRoleListSuccess = exports.recursiveRoleListLoadingDisable = exports.recursiveRoleListLoading = exports.recursiveRoleListRequest = exports.recursiveApprovalChannelListReset = exports.recursiveApprovalChannelListFail = exports.recursiveApprovalChannelListSuccess = exports.recursiveApprovalChannelListLoadingDisable = exports.recursiveApprovalChannelListLoading = exports.recursiveApprovalChannelListRequest = exports.approvalNotificationMediumListReset = exports.approvalNotificationMediumListFail = exports.approvalNotificationMediumListSuccess = exports.approvalNotificationMediumListLoading = exports.approvalNotificationMediumListRequest = void 0;

var _constants = require("./constants");

var approvalNotificationMediumListRequest = function approvalNotificationMediumListRequest() {
  return {
    type: _constants.approvalNotificationMediumListType.APPROVAL_NOTIFICATION_MEDIUM_LIST_REQUEST
  };
};

exports.approvalNotificationMediumListRequest = approvalNotificationMediumListRequest;

var approvalNotificationMediumListLoading = function approvalNotificationMediumListLoading() {
  return {
    type: _constants.approvalNotificationMediumListType.APPROVAL_NOTIFICATION_MEDIUM_LIST_LOADING
  };
};

exports.approvalNotificationMediumListLoading = approvalNotificationMediumListLoading;

var approvalNotificationMediumListSuccess = function approvalNotificationMediumListSuccess(payload) {
  return {
    type: _constants.approvalNotificationMediumListType.APPROVAL_NOTIFICATION_MEDIUM_LIST_SUCCESS,
    payload: payload
  };
};

exports.approvalNotificationMediumListSuccess = approvalNotificationMediumListSuccess;

var approvalNotificationMediumListFail = function approvalNotificationMediumListFail(payload) {
  return {
    type: _constants.approvalNotificationMediumListType.APPROVAL_NOTIFICATION_MEDIUM_LIST_FAILURE,
    payload: payload
  };
};

exports.approvalNotificationMediumListFail = approvalNotificationMediumListFail;

var approvalNotificationMediumListReset = function approvalNotificationMediumListReset() {
  return {
    type: _constants.approvalNotificationMediumListType.APPROVAL_NOTIFICATION_MEDIUM_LIST_RESET
  };
}; // here next is token which is user for pagination


exports.approvalNotificationMediumListReset = approvalNotificationMediumListReset;

var recursiveApprovalChannelListRequest = function recursiveApprovalChannelListRequest(_ref) {
  var notificationMediumId = _ref.notificationMediumId,
      next = _ref.next;
  return {
    type: _constants.approvalChannelListType.RECURSIVE_APPROVAL_CHANNEL_LIST_REQUEST,
    payload: {
      notificationMediumId: notificationMediumId,
      next: next
    }
  };
};

exports.recursiveApprovalChannelListRequest = recursiveApprovalChannelListRequest;

var recursiveApprovalChannelListLoading = function recursiveApprovalChannelListLoading() {
  return {
    type: _constants.approvalChannelListType.RECURSIVE_APPROVAL_CHANNEL_LIST_LOADING
  };
};

exports.recursiveApprovalChannelListLoading = recursiveApprovalChannelListLoading;

var recursiveApprovalChannelListLoadingDisable = function recursiveApprovalChannelListLoadingDisable() {
  return {
    type: _constants.approvalChannelListType.RECURSIVE_APPROVAL_CHANNEL_LIST_LOADING_DISABLE
  };
};

exports.recursiveApprovalChannelListLoadingDisable = recursiveApprovalChannelListLoadingDisable;

var recursiveApprovalChannelListSuccess = function recursiveApprovalChannelListSuccess(payload) {
  return {
    type: _constants.approvalChannelListType.RECURSIVE_APPROVAL_CHANNEL_LIST_SUCCESS,
    payload: payload
  };
};

exports.recursiveApprovalChannelListSuccess = recursiveApprovalChannelListSuccess;

var recursiveApprovalChannelListFail = function recursiveApprovalChannelListFail(payload) {
  return {
    type: _constants.approvalChannelListType.RECURSIVE_APPROVAL_CHANNEL_LIST_FAILURE,
    payload: payload
  };
};

exports.recursiveApprovalChannelListFail = recursiveApprovalChannelListFail;

var recursiveApprovalChannelListReset = function recursiveApprovalChannelListReset() {
  return {
    type: _constants.approvalChannelListType.RECURSIVE_APPROVAL_CHANNEL_LIST_RESET
  };
};

exports.recursiveApprovalChannelListReset = recursiveApprovalChannelListReset;

var recursiveRoleListRequest = function recursiveRoleListRequest(payload) {
  return {
    type: _constants.rolesListType.RECURSIVE_ROLES_LIST_REQUEST,
    payload: payload
  };
};

exports.recursiveRoleListRequest = recursiveRoleListRequest;

var recursiveRoleListLoading = function recursiveRoleListLoading() {
  return {
    type: _constants.rolesListType.RECURSIVE_ROLES_LIST_LOADING
  };
};

exports.recursiveRoleListLoading = recursiveRoleListLoading;

var recursiveRoleListLoadingDisable = function recursiveRoleListLoadingDisable() {
  return {
    type: _constants.rolesListType.RECURSIVE_ROLES_LIST_LOADING_DISABLE
  };
};

exports.recursiveRoleListLoadingDisable = recursiveRoleListLoadingDisable;

var recursiveRoleListSuccess = function recursiveRoleListSuccess(payload) {
  return {
    type: _constants.rolesListType.RECURSIVE_ROLES_LIST_SUCCESS,
    payload: payload
  };
};

exports.recursiveRoleListSuccess = recursiveRoleListSuccess;

var recursiveRoleListFail = function recursiveRoleListFail(payload) {
  return {
    type: _constants.rolesListType.RECURSIVE_ROLES_LIST_FAILURE,
    payload: payload
  };
};

exports.recursiveRoleListFail = recursiveRoleListFail;

var recursiveRoleListReset = function recursiveRoleListReset() {
  return {
    type: _constants.rolesListType.RECURSIVE_ROLES_LIST_RESET
  };
};

exports.recursiveRoleListReset = recursiveRoleListReset;

var recursivePermissionListRequest = function recursivePermissionListRequest(payload) {
  return {
    type: _constants.permissionsListType.RECURSIVE_PERMISSIONS_LIST_REQUEST,
    payload: payload
  };
};

exports.recursivePermissionListRequest = recursivePermissionListRequest;

var recursivePermissionListLoading = function recursivePermissionListLoading() {
  return {
    type: _constants.permissionsListType.RECURSIVE_PERMISSIONS_LIST_LOADING
  };
};

exports.recursivePermissionListLoading = recursivePermissionListLoading;

var recursivePermissionListDisableLoading = function recursivePermissionListDisableLoading() {
  return {
    type: _constants.permissionsListType.RECURSIVE_PERMISSIONS_LIST_LOADING_DISABLE
  };
};

exports.recursivePermissionListDisableLoading = recursivePermissionListDisableLoading;

var recursivePermissionListSuccess = function recursivePermissionListSuccess(payload) {
  return {
    type: _constants.permissionsListType.RECURSIVE_PERMISSIONS_LIST_SUCCESS,
    payload: payload
  };
};

exports.recursivePermissionListSuccess = recursivePermissionListSuccess;

var recursivePermissionListFail = function recursivePermissionListFail(payload) {
  return {
    type: _constants.permissionsListType.RECURSIVE_PERMISSIONS_LIST_FAILURE,
    payload: payload
  };
};

exports.recursivePermissionListFail = recursivePermissionListFail;

var recursivePermissionListReset = function recursivePermissionListReset() {
  return {
    type: _constants.permissionsListType.RECURSIVE_PERMISSIONS_LIST_RESET
  };
};

exports.recursivePermissionListReset = recursivePermissionListReset;

var createPolicyRequest = function createPolicyRequest(data, history, consumer, consumerEntityId, redirectPath) {
  return {
    type: _constants.AddPolicyType.POLICY_CREATE_REQUEST,
    payload: {
      data: data,
      history: history,
      consumer: consumer,
      consumerEntityId: consumerEntityId,
      redirectPath: redirectPath
    }
  };
};

exports.createPolicyRequest = createPolicyRequest;

var createPolicyLoading = function createPolicyLoading() {
  return {
    type: _constants.AddPolicyType.POLICY_CREATE_LOADING
  };
};

exports.createPolicyLoading = createPolicyLoading;

var createPolicySuccess = function createPolicySuccess(response) {
  return {
    type: _constants.AddPolicyType.POLICY_CREATE_SUCCESS,
    payload: response
  };
};

exports.createPolicySuccess = createPolicySuccess;

var createPolicyFailure = function createPolicyFailure(reason) {
  return {
    type: _constants.AddPolicyType.POLICY_CREATE_FAILURE,
    payload: reason
  };
};

exports.createPolicyFailure = createPolicyFailure;

var fetchProfileSettingsRequest = function fetchProfileSettingsRequest(consumerEntityId) {
  return {
    type: _constants.ProfileSettingsType.PROFILE_SETINGS_REQUEST,
    payload: consumerEntityId
  };
};

exports.fetchProfileSettingsRequest = fetchProfileSettingsRequest;

var profileSettingsSuccess = function profileSettingsSuccess(response) {
  return {
    type: _constants.ProfileSettingsType.PROFILE_SETINGS_SUCCESS,
    payload: response
  };
};

exports.profileSettingsSuccess = profileSettingsSuccess;

var profileSettingsFailure = function profileSettingsFailure(reason) {
  return {
    type: _constants.ProfileSettingsType.PROFILE_SETINGS_FAILURE,
    payload: reason
  };
};

exports.profileSettingsFailure = profileSettingsFailure;